module.exports = __webpack_public_path__ + "img/iconservice.45a78c78.png";